// Transforms one object into another object by filtering its keys and mapping its values.

/**
 *
 * Example:
 * const input = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e' };
 * const output = filterAndMapObject(input, key => key % 2 === 0, (key, value) => value.toUpperCase() + key);
 * console.log(output);
 * // { 2: 'B2', 4: 'D4' }
 */
export default function filterAndMapObject(object, filter, map = (key, value) => value) {
  return object
    ? Object.keys(object).reduce((acc, value) => {
      if (filter(value)) {
        acc[value] = map(value, object[value]); // eslint-disable-line no-param-reassign
      }
      return acc;
    }, {})
    : object;
}
